import { all, takeLatest, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import axiosMethod from 'utilities/apiCaller'

import actions from './action'

const { CAPrivateGet, cAPrivatePost } = axiosMethod

const getCurrencyAccountsList = token => {
  return CAPrivateGet(`currency-accounts`, token).then(response => {
    return response.data.data
  })
}

export function* getAllCurrencyAccounts(values) {
  try {
    const response = yield call(getCurrencyAccountsList, values.token)
    yield put({
      type: actions.GET_CURRENCY_ACCOUNTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CURRENCY_ACCOUNTS_FAILURE,
      payload: err,
    })
  }
}

const addCurrencyAccount = (body, token) => {
  return cAPrivatePost(`currency-accounts`, body, token).then(response => {
    return response.data
  })
}

export function* addAccountByCurrency(values) {
  try {
    const response = yield call(addCurrencyAccount, values.value, values.token)
    yield put({
      type: actions.ADD_ACCOUNT_BY_CURRENCY_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.GET_CURRENCY_ACCOUNTS,
      token: values.token,
    })
    yield put({
      type: actions.CLOSE_CURRENCY_LIST_MODAL,
    })
    notification.success({
      message: response.message,
    })
  } catch (err) {
    yield put({
      type: actions.ADD_ACCOUNT_BY_CURRENCY_FAILURE,
      payload: err,
    })
    if (err.response !== undefined) {
      notification.error({
        message: err.response.data.message,
      })
    } else {
      notification.error({
        message: 'Something went wrong!',
        description: 'We are currently working on it. Please try again...!',
      })
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_CURRENCY_ACCOUNTS, getAllCurrencyAccounts),
    takeLatest(actions.ADD_ACCOUNT_BY_CURRENCY, addAccountByCurrency),
  ])
}
